const APIS = {
  NOTICE: '/supportservice/api/notice/',
  TICKET: '/helpdeskservice/api/ticket/',
  USER: '/usermanagementservice/api/user/',
  USER_PROFILE: '/logisticservice/api/user-profile/',
  MERCHANT: 'logisticservice/api/merchant/',
  SUBJECT: '/helpdeskservice/api/queue/',
  PRIORITY: '/helpdeskservice/api/priority/',
};

export default APIS;
